import React from "react";

function IssueReport({ issueReport }) {
  return (
    <div>
      <table className="min-w-full overflow-y-visible bg-white  border-gray-200 rounded-md">
        {/* Table Head  */}
        <thead>
          <tr className="bg-gray-100 ">
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
              Sl No.
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
              Building Name
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
              Total Issues
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
              Resolved Issues
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
              In Progress Issues
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-r-xl">
              Invalidate Issues
            </th>
          </tr>
        </thead>

        {/* Table Body  */}
        <tbody>
          {issueReport?.length > 0
            ? issueReport?.map((data, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-200 hover:bg-gray-50"
                >
                  <td className="py-4 px-6 text-sm text-primaryTextColor">
                    {index + 1}
                  </td>

                  <td className="py-4 px-6 text-sm text-primaryTextColor">
                    {data.buildingName}
                  </td>

                  <td className="py-4 px-6 text-sm text-primaryTextColor">
                    {data.totalIssues}
                  </td>

                  <td className="py-4 px-6 text-sm text-primaryTextColor">
                    {data.resolvedIssues}
                  </td>

                  <td className="py-4 px-6 text-sm text-primaryTextColor">
                    {data.inProgressIssues}
                  </td>

                  <td className="py-4 px-6 text-sm text-primaryTextColor">
                    {data.invalidatedIssues}
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </table>
    </div>
  );
}

export default IssueReport;
